import React from 'react';
import './footer.scss';
import twitter from '../../../Assets/social/twitter.svg'
import discord from '../../../Assets/social/discord.svg'
// import opensea from '../../../Assets/social/opensea.svg'
const Footer = () => {
    return (
        <>
            <footer class="site-footer">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 col-sm-6 col-xs-12">
                            <p class="copyright-text">Copyright © 2021
                            </p>
                        </div>

                        <div class="col-md-4 col-sm-6 col-xs-12">
                            <ul class="social-icons">
                                <li className="mt6"><a href="https://twitter.com/FinanceJft" target="_blank" rel="noreferrer"  className="social_link"><img src={twitter} alt="" /> </a></li>
                                <li className="mt6"><a  href="https://discord.com/invite/2Ek5X2wtth" target="_blank" rel="noreferrer" className="social_link"><img src={discord} alt="" /> </a></li>    
                                {/* <li className="mt6"><a className="social_link"><img src={opensea} /> </a></li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;
